import { render } from "./EligibilityCriteria.vue?vue&type=template&id=00c38916&scoped=true"
import script from "./EligibilityCriteria.vue?vue&type=script&lang=js"
export * from "./EligibilityCriteria.vue?vue&type=script&lang=js"

import "./EligibilityCriteria.vue?vue&type=style&index=0&id=00c38916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c38916"]])

export default __exports__